<template>
  <div
    class="basic-accordion critical-component-clear section-content-padding"
    :class="[
      background,
      {
        'basic-accordion--checklist': liquid.settings.enable_checklist,
        [$class('sticky')]: liquid.settings.enable_sticky
      }
    ]"
  >
    <div class="grid container">
      <div class="col xs4 l2-5 basic-accordion__content">
        <eyebrow
          v-if="liquid.settings.eyebrow"
          :enable-bullet="liquid.settings.eyebrow_bullet"
          :text="liquid.settings.eyebrow"
        />
        <highlighter-title
          v-if="liquid.settings.highlighter_copy"
          class="basic-accordion__title"
          :highlighter-color="liquid.settings.highlighter_color"
          :highlighter-copy="liquid.settings.highlighter_copy"
          custom-element="h1"
        />

        <div
          v-if="liquid.settings.description"
          class="basic-accordion__description body-1"
          v-html="$cleanRTE(liquid.settings.description)"
        />

        <btn
          v-if="liquid.settings.button_url && liquid.settings.button_text"
          block-class="basic-accordion"
          :modifiers="liquid.settings.button_style"
          :label="liquid.settings.button_text"
          :url="liquid.settings.button_url"
          :icon="liquid.settings.enable_checklist ?
            'misc.save' :
            'direction.arrow.right'
          "
          :target="liquid.settings.enable_checklist ? '_blank' : ''"
        />
      </div>

      <accordion
        v-if="liquid.blocks.length > 0"
        class="col xs4 l7-12"
        :background="background"
        :multi-open="true"
        :items="accordionItems"
      />

      <div
        v-if="liquid.settings.button_url &&
          liquid.settings.button_text &&
          liquid.settings.enable_checklist
        "
        v-show="isMobile"
        class="col xs4"
      >
        <btn
          :label="liquid.settings.button_text"
          :modifiers="liquid.settings.button_style"
          :url="liquid.settings.button_url"
          block-class="basic-accordion"
          icon="misc.save"
          :target="liquid.settings.enable_checklist ? '_blank' : ''"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Basic accordion (basic-accordion)
 * -----------------------------------------------------------------------------
 * An accordion with focus on text and cta.
 *
 * @param {String} background - Background color to apply to image loading
 * state.
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {Object} liquid.settings - Section's settings.
 * @param {Array} liquid.blocks - Section's blocks.
 */

import { mapState } from 'vuex'
import Accordion from '~async/accordion/accordion'
import HighlighterTitle from '~global/highlighter-title/highlighter-title'

export default {
  name: 'BasicAccordion',

  components: {
    Accordion,
    HighlighterTitle,
  },

  props: {
    background: {
      type: String,
      default: '',
    },
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        settings: {},
        blocks: [],
      }),
    },
  },

  data() {
    return {
      accordionItems: [],
    }
  },

  mounted() {
    this.updateAccordionItems()
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  methods: {

    /**
     * Generate an array of accordion items from block settings with
     * additional information.
     * - The active state of the accordion block
     * - The block ID
     */
    updateAccordionItems() {
      this.liquid.blocks.forEach((block) => {
        const settings = block.settings
        settings.id = block.id

        this.accordionItems.push(settings)
      })
    },
  },
}
</script>

<style lang="scss">
@import './basic-accordion';
</style>
